import { apiPost } from './api';

// 店铺运营数据（订单列表）
export const orderList = (data) => {
	return apiPost('/ecommerce/operationStatistic/orderList', data);
};

// 商品运营数据列表
export const goodsList = (data) => {
	return apiPost('/ecommerce/operationStatistic/goodsList', data);
};
